import { Grid, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { getData, storeData, callChoice } from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import { isMobile } from "react-device-detect";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import RadioComponent from "../../components/ChoiceComponent/RadioComponent";
import DialogWait from "../../components/CustomDialog/DialogWait";
import { isEmpty } from "lodash";
import Loading from "../../components/loading/loading";
import GlobalApi from "../../utils/GlobalApi";
import Configs from "../../constants/Configs";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";

const header = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
};
const useStyle = makeStyles({
  paddingTopBottom: {
    padding: "10px 0",
  },
});

const Suit15 = (props) => {
  const classes = useStyle();
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModelWait, setIsModelWait] = useState(false);
  const [isModelWaitText, setIsModelWaitText] = useState({
    title: "",
    massage: "",
    btn: "",
  });
  const [suitJson, setSuitJson] = useState(getData("suit_json"));
  const [answerjson14, setAnswerjson14] = useState(
    !isEmpty(getData("answerjson14"))
      ? getData("answerjson14")
      : [
          {
            SAfsa14_Id: -1,
            positionName: "",
            companyName: "",
            expFrom: "",
            expTo: "",
            Delflag: "",
          },
        ],
  );
  const [isCheck, setIsCheck] = useState(false);
  const chooce = getData("chooce")?.["1"];
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const career = getData("f3_career");
  let snapIdCard = getData("uploadImage");

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suitJson)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const handleNext = () => {
    PostSuit();
  };
  const PostSuit = async () => {
    setIsLoading(true);
    try {
      let dataSuit = [...suitJson];
      dataSuit.forEach((e, i) => {
        if (e.SAfsac_SAmsa_Id === 25) {
          e.SAfsac_Remark2 = e.SAfsac_Remark2.toString();
        }
      });
      let arrayJson = {
        head_token,
        suit_json: [...dataSuit],
        answerjson14: [...answerjson14],
      };
      GlobalApi.post(Configs.baseAPIURL03 + "/form/suitability/manp", arrayJson)
        .then((res) => {
          setIsLoading(false);
          if (res?.status === API_CODE_SUCCESS) {
            storeData("suitability", res.data.Data?.[1]?.[0]);
            storeData("suit_json", suitJson);
            storeData("answerjson14", answerjson14);
            props.history.push("/suit_result");
          }
        })
        .catch((er) => {
          setIsLoading(false);
          setIsModelWait(true);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModelWait(true);
    }
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) setJumpPage(true);
    });
  }, []);
  useEffect(() => {
    let check = 0;
    let suitData = [...suitJson];
    suitData.forEach((suit, i) => {
      if (i > 11) {
        if (suit.SAfsac_Answer.toString() === "1") {
          if (
            suit.SAfsac_SAmsa_Id === 25 &&
            !isEmpty(suit.SAfsac_SubAnswer) &&
            !isEmpty(suit.SAfsac_Remark) &&
            !isEmpty(suit.SAfsac_Remark2)
          ) {
            check++;
          } else if (suit.SAfsac_SAmsa_Id === 26) {
            if (!isEmpty(suit.SAfsac_SubAnswer)) {
              const sub = suit.SAfsac_SubAnswer?.split("_");
              if (sub.includes("" + 5)) {
                if (!isEmpty(suit.SAfsac_Remark)) {
                  check++;
                }
              } else {
                check++;
              }
            }
          } else if (suit.SAfsac_SAmsa_Id === 29) {
            if (!isEmpty(suit.SAfsac_SubAnswer)) {
              const sub = suit.SAfsac_SubAnswer?.split("_");
              if (sub.includes("" + 15)) {
                let check14 = 0;
                answerjson14.forEach((ans) => {
                  if (
                    !isEmpty(ans.positionName) &&
                    !isEmpty(ans.companyName) &&
                    !isEmpty(ans.expFrom) &&
                    !isEmpty(ans.expTo)
                  ) {
                    check14++;
                  }
                });
                if (check14 === answerjson14.length) {
                  check++;
                }
              } else {
                check++;
              }
            }
          } else if (
            suit.SAfsac_SAmsa_Id === 33 &&
            !isEmpty(suit.SAfsac_SubAnswer)
          ) {
            check++;
          }
        } else if (suit.SAfsac_Answer.toString() === "2") {
          check++;
        }
      }
    });
    if (check > 3) {
      setIsCheck(true);
    } else {
      setIsCheck(false);
    }
  }, [suitJson, answerjson14]);
  useEffect(() => {
    if (!isEmpty(isModelWaitText.title)) setIsModelWait(true);
  }, [isModelWaitText]);
  useEffect(() => {
    const translation = getData("Translations");
    if (!isEmpty(translation)) {
      setTranslations(translation);
    } else {
      props.history.push("/");
    }
  }, []);
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.suit?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? props.history.push("/suit_12") : "")}
          />
          <DialogWait
            open={isModelWait}
            isModel={setIsModelWait}
            title={isModelWaitText.title}
            massage={isModelWaitText.massage}
            btn={isModelWaitText.btn}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.suit}
                        clickBack={(e) => props.history.push("/suit_12")}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.suit?.title}
                          />
                          <ScrollBarComponent
                            content={
                              <>
                                <Grid>
                                  <Grid>
                                    <Typography className="text-primary font-weight-bold font-20">
                                      {
                                        translations?.[lang]?.suit
                                          ?.suit_question_title_15
                                      }
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    className={clsx(
                                      "font-DBHeavent",
                                      "font-18",
                                      classes.paddingTopBottom,
                                    )}
                                  >
                                    {
                                      translations?.[lang]?.suit
                                        ?.suit_question_description_15
                                    }
                                  </Grid>
                                  <Grid>
                                    {chooce?.map(
                                      (items, i) =>
                                        i > 11 && (
                                          <Grid key={i}>
                                            <Grid
                                              className={clsx(
                                                "font-DBHeavent",
                                                "font-20",
                                                "text-primary",
                                              )}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  lang === "en"
                                                    ? items?.SAmsa_EnQuestion
                                                    : items?.SAmsa_Question,
                                              }}
                                            />
                                            <RadioComponent
                                              SAfsac_SubAnswer={
                                                suitJson?.[i]?.SAfsac_SubAnswer
                                              }
                                              answerjson14={answerjson14}
                                              onChangeAnswer14={setAnswerjson14}
                                              suitJson={suitJson?.[i]}
                                              choice={
                                                lang === "en"
                                                  ? JSON.parse(
                                                      items?.SAmsa_EnAnswer,
                                                    )
                                                  : JSON.parse(
                                                      items?.SAmsa_Answer,
                                                    )
                                              }
                                              handleChange={(e) => {
                                                try {
                                                  suitJson[i].SAfsac_Answer =
                                                    parseInt(e.target.value);
                                                  suitJson[i].SAfsac_Score =
                                                    parseInt(e.target.value);
                                                  if (
                                                    suitJson[i]
                                                      .SAfsac_Answer === 2
                                                  ) {
                                                    suitJson[
                                                      i
                                                    ].SAfsac_SubAnswer = "";
                                                    suitJson[i].SAfsac_Remark =
                                                      "";
                                                    suitJson[i].SAfsac_Remark2 =
                                                      "";
                                                    setAnswerjson14([
                                                      {
                                                        SAfsa14_Id: -1,
                                                        positionName: "",
                                                        companyName: "",
                                                        expFrom: "",
                                                        expTo: "",
                                                        Delflag: "",
                                                      },
                                                    ]);
                                                  }
                                                  setSuitJson([...suitJson]);
                                                } catch (error) {
                                                  // console.log(error);
                                                  setIsModelWaitText({
                                                    title: "เกิดข้อผิดพลาด",
                                                    massage:
                                                      "กรุณาลองใหม่อีกครั้ง",
                                                    btn: "ตกลง",
                                                  });
                                                }
                                              }}
                                              handleChangeSubAnswer={(e) => {
                                                suitJson[i].SAfsac_SubAnswer =
                                                  e.SAfsac_SubAnswer;
                                                setSuitJson([...suitJson]);
                                              }}
                                              handleChangeRemark={(e) => {
                                                suitJson[i].SAfsac_Remark =
                                                  e.target.value;
                                                setSuitJson([...suitJson]);
                                              }}
                                              handleChangeRemark2={(e) => {
                                                suitJson[i].SAfsac_Remark2 =
                                                  e?.value;
                                                setSuitJson([...suitJson]);
                                              }}
                                            />
                                          </Grid>
                                        ),
                                    )}
                                  </Grid>
                                </Grid>
                              </>
                            }
                          />{" "}
                          <ButtonRight
                            isDisbled
                            disbled={isCheck}
                            text={translations?.[lang]?.suit?.next}
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
export default memo(Suit15);
